// extracted by mini-css-extract-plugin
export default {"container":"OrgTable_container__onFuZ","table":"OrgTable_table__Q0EHb","delete":"OrgTable_delete__Ku-ez","not-implemented":"OrgTable_not-implemented__fVXrk"};